import { __exports as TokenEngine } from './_virtual-TokenEngine.js';
import { __require as requireWeb_domCollections_iterator } from './node_modules-core-js-modules-web.dom-collections.iterator.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireAsLowAsPricePerPiece } from './vp-js-token-engine-build-filters-asLowAsPricePerPiece.js';
import { __require as requireLabeledPrice } from './vp-js-token-engine-build-filters-labeledPrice.js';
import { __require as requirePricePerUnit } from './vp-js-token-engine-build-filters-pricePerUnit.js';
import { __require as requirePricePerPackage } from './vp-js-token-engine-build-filters-pricePerPackage.js';
import { __require as requirePricePerRecipient } from './vp-js-token-engine-build-filters-pricePerRecipient.js';
import { __require as requireQtyStartingAtPrice } from './vp-js-token-engine-build-filters-qtyStartingAtPrice.js';
import { __require as requireQtyForOnly } from './vp-js-token-engine-build-filters-qtyForOnly.js';
import { __require as requirePriceForQtyUnits } from './vp-js-token-engine-build-filters-priceForQtyUnits.js';
import { __require as requirePercentOff } from './vp-js-token-engine-build-filters-percentOff.js';
import { __require as requireYouSaved } from './vp-js-token-engine-build-filters-youSaved.js';
import { __require as requirePlusOrMinus } from './vp-js-token-engine-build-filters-plusOrMinus.js';
import { __require as requirePlusOrMinusPerUnit } from './vp-js-token-engine-build-filters-plusOrMinusPerUnit.js';
import { __require as requireRawPrice } from './vp-js-token-engine-build-filters-rawPrice.js';
import { __require as requireCouponCallout } from './vp-js-token-engine-build-filters-couponCallout.js';
import { __require as requireQtyForPrice } from './vp-js-token-engine-build-filters-qtyForPrice.js';
import { __require as requireQtyFromPrice } from './vp-js-token-engine-build-filters-qtyFromPrice.js';
import { __require as requireVatMessage } from './vp-js-token-engine-build-filters-vatMessage.js';
import { __require as requireRangePrice } from './vp-js-token-engine-build-filters-rangePrice.js';
import { __require as requireUrl } from './vp-js-token-engine-build-filters-url.js';
import { __require as requireLegal } from './vp-js-token-engine-build-filters-legal.js';
import { __require as requireCare } from './vp-js-token-engine-build-filters-care.js';
import { __require as requireAllcaps } from './vp-js-token-engine-build-filters-allcaps.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireLogger } from './vp-js-token-engine-build-infrastructure-logger.js';

var hasRequiredTokenEngine;

function requireTokenEngine () {
	if (hasRequiredTokenEngine) return TokenEngine;
	hasRequiredTokenEngine = 1;

	requireWeb_domCollections_iterator();
	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(TokenEngine, "__esModule", {
	  value: true
	});
	TokenEngine.default = void 0;
	requireEs_string_replace();
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var asLowAsPricePerPiece = _interopRequireWildcard(requireAsLowAsPricePerPiece());
	var labeledPrice = _interopRequireWildcard(requireLabeledPrice());
	var pricePerUnit = _interopRequireWildcard(requirePricePerUnit());
	var pricePerPackage = _interopRequireWildcard(requirePricePerPackage());
	var pricePerRecipient = _interopRequireWildcard(requirePricePerRecipient());
	var qtyStartingAtPrice = _interopRequireWildcard(requireQtyStartingAtPrice());
	var qtyForOnly = _interopRequireWildcard(requireQtyForOnly());
	var priceForQtyUnits = _interopRequireWildcard(requirePriceForQtyUnits());
	var percentOff = _interopRequireWildcard(requirePercentOff());
	var youSaved = _interopRequireWildcard(requireYouSaved());
	var plusOrMinus = _interopRequireWildcard(requirePlusOrMinus());
	var plusOrMinusPerUnit = _interopRequireWildcard(requirePlusOrMinusPerUnit());
	var rawPrice = _interopRequireWildcard(requireRawPrice());
	var couponCallout = _interopRequireWildcard(requireCouponCallout());
	var qtyForPrice = _interopRequireWildcard(requireQtyForPrice());
	var qtyFromPrice = _interopRequireWildcard(requireQtyFromPrice());
	var vatMessage = _interopRequireWildcard(requireVatMessage());
	var rangePrice = _interopRequireWildcard(requireRangePrice());
	var url = _interopRequireWildcard(requireUrl());
	var legal = _interopRequireWildcard(requireLegal());
	var care = _interopRequireWildcard(requireCare());
	var allcaps = _interopRequireWildcard(requireAllcaps());
	var _container = requireContainer();
	var _logger = requireLogger();
	function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
	function _interopRequireWildcard(e, r) { if (e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // Price presentation filters
	// URL filter
	// Care
	// Small-caps
	let TokenEngine$1 = class TokenEngine {
	  constructor(culture, tenant) {
	    (0, _defineProperty2.default)(this, "urlClient", void 0);
	    (0, _defineProperty2.default)(this, "culture", void 0);
	    (0, _defineProperty2.default)(this, "tenant", void 0);
	    if (!culture) {
	      return;
	    }
	    this.urlClient = _container.urlClientFactory.create();
	    this.culture = culture;
	    _container.engine.registerFilter(asLowAsPricePerPiece.name, asLowAsPricePerPiece.filter);
	    _container.engine.registerFilter(labeledPrice.name, labeledPrice.filter);
	    _container.engine.registerFilter(pricePerUnit.name, pricePerUnit.filter);
	    _container.engine.registerFilter(pricePerPackage.name, pricePerPackage.filter);
	    _container.engine.registerFilter(pricePerRecipient.name, pricePerRecipient.filter);
	    _container.engine.registerFilter(qtyStartingAtPrice.name, qtyStartingAtPrice.filter);
	    _container.engine.registerFilter(qtyForOnly.name, qtyForOnly.filter);
	    _container.engine.registerFilter(priceForQtyUnits.name, priceForQtyUnits.filter);
	    _container.engine.registerFilter(percentOff.name, percentOff.filter);
	    _container.engine.registerFilter(youSaved.name, youSaved.filter);
	    _container.engine.registerFilter(plusOrMinus.name, plusOrMinus.filter);
	    _container.engine.registerFilter(plusOrMinusPerUnit.name, plusOrMinusPerUnit.filter);
	    _container.engine.registerFilter(rawPrice.name, rawPrice.filter);
	    _container.engine.registerFilter(couponCallout.name, couponCallout.filter);
	    _container.engine.registerFilter(qtyForPrice.name, qtyForPrice.filter);
	    _container.engine.registerFilter(qtyFromPrice.name, qtyFromPrice.filter);
	    _container.engine.registerFilter(vatMessage.name, vatMessage.filter);
	    _container.engine.registerFilter(rangePrice.name, rangePrice.filter);
	    _container.engine.registerFilter(allcaps.name, allcaps.filter);
	    if (!tenant) {
	      return;
	    }
	    this.tenant = tenant;
	    _container.engine.registerFilter(url.name, url.filter);
	    _container.engine.registerFilter(legal.name, legal.filter);
	    _container.engine.registerFilter(care.name, care.filter);
	  }
	  async render(text) {
	    let variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    try {
	      if (!this.culture) {
	        throw new Error('culture not set');
	      }
	      return await _container.engine.parseAndRender(text, _objectSpread({
	        culture: this.culture,
	        tenant: this.tenant,
	        urlClient: this.urlClient
	      }, variables));
	    } catch (error) {
	      _logger.logger.error(error, {
	        contextData: {
	          stack: error.stack,
	          culture: this.culture,
	          tenant: this.tenant
	        }
	      });
	      throw new Error(error);
	    }
	  }

	  // TODO: This could be replaced with renderSync form LiquidJS 9
	  replace(text) {
	    let variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    try {
	      return _container.mustacheService.replace(text, variables);
	    } catch (error) {
	      _logger.logger.error(error, {
	        contextData: {
	          stack: error.stack,
	          culture: this.culture,
	          tenant: this.tenant
	        }
	      });
	      throw new Error(error);
	    }
	  }
	  async fillUrlCache() {
	    try {
	      if (!this.culture) {
	        throw new Error('culture not set');
	      }
	      if (!this.tenant) {
	        throw new Error('tenant not set');
	      }
	      await this.urlClient.fillUrlCache(this.culture, this.tenant);
	    } catch (error) {
	      _logger.logger.error("fillUrlCache failed for locale ".concat(this.culture, " and tenant ").concat(this.tenant), {
	        contextData: {
	          culture: this.culture,
	          stack: error.stack,
	          error,
	          tenant: this.tenant
	        }
	      });
	      throw new Error("fillUrlCache failed for locale ".concat(this.culture, " and tenant ").concat(this.tenant, ": ").concat(error));
	    }
	  }
	};
	TokenEngine.default = TokenEngine$1;
	
	return TokenEngine;
}

export { requireTokenEngine as __require };
//# sourceMappingURL=vp-js-token-engine-build-TokenEngine.js.map
